import LayoutTerms from "components/LayoutTerms";
import { termsAndConditions } from "utils/constans";

const TermsAndConditions = () => {
  return (<LayoutTerms terms={termsAndConditions} title="TERMS OF USE"/>);
};
export default TermsAndConditions;
